const BaseModule = require('_base/base')
const VideoObserver = require('./lib/videosIntersectionObserver')

class VideoPlayInView extends BaseModule {
  postInit() {
    this.$wrapper = this.spread._book.$el || this.spread.$el || $()

    if (!window.application.videoObserver) {
      window.application.videoObserver = new VideoObserver(this.$wrapper)

      this.bindEvents()
    }
  }

  bindEvents() {
    this.$spread.on('spreadInSight webpageReady', () => {
      window.application.videoObserver.startObserving()
    })
  }
}

$('.js__playInView').each(function() {
  new VideoPlayInView($(this))
})
